import { API_CONFIG } from "@/infrastructure/config/api";

/**
 * Response type for unsubscribe request
 */
export interface UnsubscribeResponse {
  success: boolean;
  status: number;
  message?: string;
}

/**
 * Service for handling invite unsubscribe operations
 */
class InviteService {
  /**
   * Unsubscribe from invite using token
   * This is a public endpoint and does not require authentication
   * 
   * @param token - JWT token from the unsubscribe link
   * @returns Promise with unsubscribe response
   */
  public static async unsubscribe(token: string): Promise<UnsubscribeResponse> {
    try {
      // Build the unsubscribe URL
      const baseUrl = API_CONFIG.API_URL.endsWith('/api') 
        ? API_CONFIG.API_URL 
        : `${API_CONFIG.API_URL}/api`;
      
      const url = `${baseUrl}/invites/unsubscribe/${token}`;
      
      // Make the request without authentication (public endpoint)
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Return response based on status code
      return {
        success: response.ok,
        status: response.status,
        message: response.ok ? 'Unsubscribed successfully' : 'Failed to unsubscribe'
      };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // Network or other errors
      return {
        success: false,
        status: 500,
        message: error.message || 'Network error'
      };
    }
  }
}

export default InviteService;
